import { ModuleFE_Score } from './ModuleFE_Score.js';
export const ModulePackFE_ScoreDB = [ModuleFE_Score];
//# sourceMappingURL=module-pack.js.map